/**
 * Original file from app_deborla cartridge
 * Modifications:
 * - Fix eslint;
 * - Improved comments and documentation;
 * - Restructure the exported function;
 * - Add new logic to ensure that this also works in PDP;
 * - Change displayMessageAndChangeIcon function, in order to work in the APP context.
 */
'use strict';

/**
 * Product wishlist heart icon component
 */
const wishlist = {};

/**
 * Imports
 */
var processInclude = require('base/util');

/**
 * Component configuration constants
 */
const CONFIG = {
    CLASS: {
        DISABLED: 'disabled',
        ICON_FILLED: 'hom-icon-favorite-filled',
        FAVORITE: 'hom-icon-favorite'
    },
    SELECTORS: {
        COMPONENT: '.wishlistTile',
        ICON: '.hom-icon-favorite',
        PRODUCT: '.product',
        PRODUCT_DETAIL: '.product-details',
        PRODUCT_OPTION_ID: '.product-option',
        PRODUCT_OPTION_VALUE: '.options-select option:selected'
    }
};

/**
 * Private functions
 */

/**
 * Verify if all arguments have a valid value.
 * @param {any} arguments - 1 or more arguments to validate
 * @returns {boolean} true if all arguments are valid
 */
function isValid() {
    var argument;

    for (var i = 0; i < arguments.length; i++) {
        argument = arguments[i];

        if (argument === undefined && argument === null && argument === 'undefined' && argument === 'null') {
            return false;
        }
    }

    return true;
}

/**
 * renders the list up to a given page number
 * @param {number} pageNumber - current page number
 * @param {boolean} spinner - if the spinner has already started
 * @param {string} focusElementSelector - selector of the element to focus on
 */
function renderNewPageOfItems(pageNumber, spinner, focusElementSelector) {
    var publicView = $('.wishlistItemCardsData').data('public-view');
    var listUUID = $('.wishlistItemCardsData').data('uuid');
    var url = $('.wishlistItemCardsData').data('href');

    if (spinner) {
        $.spinner().start();
    }
    var scrollPosition = document.documentElement.scrollTop;
    var newPageNumber = pageNumber;
    $.ajax({
        url: url,
        method: 'get',
        data: {
            pageNumber: ++newPageNumber,
            publicView: publicView,
            id: listUUID
        }
    })
        .done(function (data) {
            $('.wishlistItemCards').empty();
            $('body .wishlistItemCards').replaceWith(data);

            if (focusElementSelector) {
                $(focusElementSelector).focus();
            } else {
                document.documentElement.scrollTop = scrollPosition;
            }
        })
        .fail(function () {
            $('.more-wl-items').remove();
        });
    $.spinner().stop();
}

/**
 * Collection of functions which set the status of an element.
 */
const setStatus = {
    /**
     * Add the disabled class to the given element.
     * @param {JQuery<HTMLElement>} $element - element to add the disabled class
     */
    disabled: function ($element) {
        if (!isValid($element)) {
            return;
        }

        $element.addClass(CONFIG.CLASS.DISABLED);
    },

    /**
     * Remove the disabled class of the given element.
     * @param {JQuery<HTMLElement>} $element - element to remove the disabled class
     */
    enabled: function ($element) {
        if (!isValid($element)) {
            return;
        }

        $element.removeClass(CONFIG.CLASS.DISABLED);
    }
};

/**
 * Collection of setter functions related with wishlist heart icon.
 */
const setIcon = {
    /**
     * Set the wishlist heart icon with the filled CSS class.
     * @param {JQuery<HTMLElement>} $icon - wishlist heart icon jquery element
     */
    filled: function ($icon) {
        if (!isValid($icon)) {
            return;
        }

        $icon.addClass(CONFIG.CLASS.ICON_FILLED);
    },
    empty: function ($icon) {
        if (!isValid($icon)) {
            return;
        }

        $icon.removeClass(CONFIG.CLASS.ICON_FILLED);
    }
};

/**
 * Collection of functions which represent server interactions.
 */
const server = {
    /**
     *
     * @param {string} url - controller endpoint URL
     * @param {string} pid - product id
     * @param {string | null} optionId - product option id. null if it there is no selected option
     * @param {string | null} optionValue - product option value. null if it there is no selected option
     * @param {JQuery<HTMLElement>} $icon - wishlist heart icon jquery element
     */
    addToWishlist: function (url, pid, optionId, optionValue, $icon) {
        // Pré AJAX call actions
        setStatus.disabled($icon);
        $.spinner().start();

        // Call Wishlist-AddProduct controller endpoint
        $.ajax({
            url: url,
            type: 'post',
            dataType: 'json',
            data: {
                pid: pid,
                optionId: optionId,
                optionVal: optionValue
            },
            success: function (data) {
                if (data.success && data.msg) {
                    $.alert().success(data.msg);
                    setIcon.filled($icon);
                }
            },
            error: function (err) {
                console.log(err);
            },
            complete: function () {
                $.spinner().stop();
                setStatus.enabled($icon);
            }
        });
    },
    removeFromWishlist: function (url, pid, $icon) {
        // Pré AJAX call actions
        setStatus.disabled($icon);
        $.spinner().start();

        // Call Wishlist-AddProduct controller endpoint
        $.ajax({
            url: url,
            type: 'get',
            data: {
                pid: pid
            },
            success: function (data) {
                if (data.success && data.message) {
                    $.alert().error(data.message.success);
                    setIcon.empty($icon);
                    const productInWishlist = $('.hom-wishlist').find('div[data-pid=' + pid + ']');
                    if (productInWishlist.length > 0) {
                        productInWishlist.remove();
                    }

                    if ($('.hom-wishlist').find('.product-tile').length === 0) {
                        var pageNumber = $('.wishlistItemCardsData').data('page-number') - 1;
                        renderNewPageOfItems(pageNumber, false);
                    }
                }
            },
            error: function (err) {
                console.log(err);
            },
            complete: function () {
                $.spinner().stop();
                setStatus.enabled($icon);
            }
        });
    }
};

/**
 * Collection of functions which attach click event listeners.
 */
const onClick = {
    /**
     * Attach on click to wishlist heart icon event listener.
     */
    click: function () {
        $('body').on('click', CONFIG.SELECTORS.COMPONENT, function (e) {
            e.preventDefault();

            // Constants
            const $this = $(this);
            const $icon = $this.hasClass(CONFIG.CLASS.FAVORITE) ? $this : $this.find(CONFIG.SELECTORS.ICON);
            const $product = $this.closest(CONFIG.SELECTORS.PRODUCT);
            const $pdp = $this.closest(CONFIG.SELECTORS.PRODUCT_DETAIL);
            const $optionId = $pdp.find(CONFIG.SELECTORS.PRODUCT_OPTION_ID);
            const $optionValue = $pdp.find(CONFIG.SELECTORS.PRODUCT_OPTION_VALUE);
            const isInWishlist = $icon.hasClass(CONFIG.CLASS.ICON_FILLED);

            // If it is already in this wishlist, remove from the list. If it isn't, add it to list.
            const url = isInWishlist ? $this.attr('data-remove-url') : $this.attr('data-add-url');

            // Variables
            var pid = $product.data('pid') || $pdp.data('pid') || null;
            var optionId = $optionId.data('option-id') || null;
            var optionValue = $optionValue.data('value-id') || null;

            // 1. Stop execution if product id and controller endpoint is not found
            if (!isValid(url) || !isValid(pid)) {
                return;
            }

            // 2. Execute AJAX call
            if (isInWishlist) {
                server.removeFromWishlist(url, pid, $icon);
            } else {
                server.addToWishlist(url, pid, optionId, optionValue, $icon);
            }
        });
    }
};

/**
 * Exposed event listener functions
 */
wishlist.setEvents = function () {
    processInclude(onClick);
};

module.exports = wishlist;
